import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseService } from '@core/services/core/base.service';
import { MMobileHelperService } from '@core/services/core/mmobile-helper.service';
import { PolicyPension } from '@models/policy-pension';
import { ProductCard } from '@models/products';

@Injectable({
  providedIn: 'root'
})
export class PensionPlanHelperService {
  policy: ProductCard & Pick<PolicyPension, 'productCode' | 'productDescription'>;

  constructor(
    private http: HttpClient,
    private base: BaseService,
    private mmobile: MMobileHelperService
  ) {}

  getTokenAFIN(username: string, password: string) {
    const url = `${this.base.getPublicBaseUrl()}/clientsArea/investment/login`;
    const headers = this.base.getPublicHeaders();
    const body = {
      username,
      password
    };

    return this.http.post(url, body, headers).toPromise();
  }

  getUrlIframe() {
    return this.mmobile.getCustomConfigData('URLS', 'AUTOSERVICE');
  }
}
